module.exports = __webpack_public_path__ + "img/logo_color_white_text.85bd0860.svg";